module.exports = __webpack_public_path__ + "static/media/banner-contact.0c1f87fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner-contact.jpg
// module id = 386
// module chunks = 0